module.exports = __webpack_public_path__ + "fonts/d8a54982fd537806f6a9beb0abea65bd.svg";